// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__Ya1bz","heading-h3":"TextButton_heading-h3__SWGVx","active":"TextButton_active__yHlTm"};